// Copyright (c) 2022 by Move Closer

import { ModulesFormRegistryEntry } from '../../../contexts'

import { productHeaderFactory } from '../ProductHeader.factory'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const productHeaderModuleEntry: ModulesFormRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "form/core" */ './ProductHeader.form.vue'
  ),
  factory: productHeaderFactory,
  icon: require('../product-header.svg'),
  label: 'modulesForms.ProductHeader._name'
}
